<script>
export default {
  data: () => ({}),
  props: {
    icon: String,
    activeIcon: String,
    active: Boolean,
    title: String,
    enabled: Boolean,
    showEnabled: Boolean,
    fDeletable: Boolean,
    fDeletableHide: Boolean,
    fDraggableClass: Boolean,
  },
};
</script>

<template>
  <span class="f-project-tab-container">
    <div
      class="f-project-tab"
      :class="{ active: active, dragable: fDraggableClass }"
    >
      <div
        class="focus"
        @click.stop="
          $emit('tabSelect');
          $emit('tabselect');
        "
        :content="title"
        v-tippy="{
          placement: 'bottom',
          arrow: false,
          boundary: 'viewport',
          delay: [500, 100],
        }"
      >
        <f-icon v-show="!active" class="project-icon" :icon="icon"></f-icon>
        <f-icon
          v-show="active"
          class="project-icon"
          :icon="activeIcon || icon"
        ></f-icon>
        <!-- <f-icon class="project-icon" icon="fa6-bolt"></f-icon> -->
        <!-- <f-icon icon="fa6-info"></f-icon> -->

        <div class="text">{{ title }}</div>

        <div class="status" v-if="showEnabled">
          <f-status :state="enabled ? 'positive' : 'negative'"></f-status>
        </div>

        <f-button
          v-if="fDeletable"
          class="close-button"
          :class="{ 'button-hide-on-drag': fDeletableHide }"
          type="icon"
          @click.stop="$emit('delete')"
        >
          <f-icon icon="fa6-close" class="s16"></f-icon>
        </f-button>
      </div>
    </div>
    <div class="separator"></div>
  </span>
</template>


<style lang="scss">
.f-project-tab-container {
  display: flex;
  flex-direction: row;

  > .separator {
    border-right: 1px solid var(--white-a10);
    height: 32px;
    margin: 8px 8px 0;
  }
}

.transparent-background .f-project-tab-container {
  > .separator {
    border-right: 1px solid var(--white-a10);
  }
}

.f-project-tab {
  max-width: calc(100% - 17px);

  &.active,
  .focus:hover {
    .f-button {
      visibility: visible;
      opacity: 1;
    }
  }

  &.active {
    .text {
      font-weight: bold;
    }
  }

  button.close-button {
    transition: opacity 125ms ease;
    visibility: hidden;
    opacity: 0;
    width: 24px;
    height: 24px;
    color: var(--white-a75);
    .f-icon {
      width: 16px;
      height: 16px;
      color: var(--white-a75);
    }

    &.button-hide-on-drag {
      opacity: 0;
    }

    &:hover {
      background-color: var(--white-a10);
    }
  }

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;

  > * {
    display: block;
  }

  height: 48px;

  transition-delay: 125ms;
  transition-timing-function: ease;
  transition-property: background-color, box-shadow;

  border-radius: 8px 8px 0px 0px;

  &.active {
    /* Grey Light */
    background: #404040;
    /* Drop shadow / Default */

    box-shadow: 0px 16px 32px rgba(22, 22, 21, 0.25);

    .project-icon {
      color: var(--primary);
    }
  }

  /* Inside auto layout */
  margin: 0px 0px;

  &:not(.active) > .focus:hover {
    background: var(--white-a10);
    cursor: pointer;
  }

  &.active.dragable > .focus:hover {
    // background: rgba(24, 144, 211, 0.1);
    cursor: grab;
  }

  &.active {
    color: var(--white-a75);
  }

  .focus {
    max-width: 100%;
    width: 100%;
    transition: 125ms ease background-color;

    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 8px;

    > * {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 18px;
      line-height: 18px;

      flex: 0 0 auto;
    }

    // position: static;
    // width: 156px;
    height: 40px;
    left: 4px;
    top: 4px;

    /* Blue/10% */

    border-radius: 6px;

    /* Inside auto layout */

    margin: 0px 4px;

    div.button {
      cursor: pointer;

      width: 16px;
      height: 16px;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .text {
    flex: 0 1 auto;

    display: inline-block;

    font-family: Lato;
    font-style: normal;
    font-size: 14px;
    line-height: 17px;
    margin: 0;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    color: var(--white-a75);
  }

  .project-icon {
    color: var(--white-a75);
  }
}
</style>


<style lang="scss">
.transparent-background .f-project-tab {
  &:not(.active),
  &.active {
    background: transparent;
    color: var(--white-a75);

    .focus:hover {
      background-color: var(--white-a25);
    }
  }
}
</style>